module.exports = __webpack_public_path__ + "img/monkey.741c95e9.svg";